// [목적] packages/ui 토큰 진입점 — 6종 토큰을 단일 객체로 export
// [이유] apps/* 가 `import { tokens } from '@gangwoncanvas/ui'` 한 줄로 모두 접근 가능하게
// [사이드 이팩트] 새 토큰 카테고리 추가 시 본 파일에 등재 필수
// [수정 시 고려사항] tokens 객체의 키가 design_structure §3 카테고리와 일치하는지 항상 확인
import { color } from './color.js';
import { motion } from './motion.js';
import { radius } from './radius.js';
import { shadow } from './shadow.js';
import { spacing } from './spacing.js';
import { typography } from './typography.js';
export const tokens = {
    color,
    typography,
    spacing,
    radius,
    shadow,
    motion,
};
export { color, typography, spacing, radius, shadow, motion };
//# sourceMappingURL=index.js.map